type Section = {
  title: string;
  body: string[];
};

const PRIVACY: Section[] = [
  {
    title: "Information we collect",
    body: [
      "mono is built to keep the product simple. We collect the information needed to operate payments, support accounts, prevent abuse, and improve reliability.",
      "This may include your phone number, contact permission status, wallet addresses you connect or create, transaction metadata, device information, diagnostics, and support messages you send us.",
    ],
  },
  {
    title: "Contacts and messages",
    body: [
      "If you grant contact access, mono uses it to help you find people to send USDC to. We do not sell your contacts.",
      "When you send through Messages, Apple and your carrier may process message content under their own terms. mono uses the message payload or link to help the recipient open or claim the payment.",
    ],
  },
  {
    title: "Payments",
    body: [
      "USDC transfers happen on public blockchain networks. Wallet addresses, transaction hashes, token amounts, and timestamps may be public by design.",
      "We may use service providers for wallet infrastructure, risk checks, analytics, hosting, customer support, and payment routing.",
    ],
  },
  {
    title: "How we use information",
    body: [
      "We use information to provide mono, process sends and claims, secure the service, debug issues, answer support requests, comply with law, and understand product performance.",
      "We do not use your personal information to sell third-party ads.",
    ],
  },
  {
    title: "Your choices",
    body: [
      "You can disable contact access in iOS Settings. You can also contact us to request access, correction, or deletion of personal information where applicable.",
      "Some blockchain records cannot be changed or deleted because they are maintained by public networks, not mono.",
    ],
  },
  {
    title: "Contact",
    body: [
      "Questions about privacy can be sent to privacy@textmono.com.",
    ],
  },
];

const TERMS: Section[] = [
  {
    title: "Using mono",
    body: [
      "mono lets people send and claim supported digital dollars, starting with USDC, through iMessage and compatible links.",
      "You are responsible for making sure the recipient, amount, asset, and network are correct before sending.",
    ],
  },
  {
    title: "Wallets and transactions",
    body: [
      "Blockchain transactions may be irreversible. mono cannot guarantee that an incorrect, completed, or claimed transfer can be reversed.",
      "Network conditions, wallet providers, bridges, relayers, or third-party services may delay or fail transactions.",
    ],
  },
  {
    title: "Eligibility",
    body: [
      "You may use mono only if you can legally use digital asset services in your location and are not barred by sanctions, law, or platform rules.",
      "Do not use mono for illegal activity, fraud, abuse, or attempts to bypass compliance controls.",
    ],
  },
  {
    title: "Fees and availability",
    body: [
      "Network, relay, exchange, or third-party fees may apply. We will try to show relevant costs before you send when they are known.",
      "mono may change, pause, or discontinue features as we develop the product.",
    ],
  },
  {
    title: "No financial advice",
    body: [
      "mono is a payments product. We do not provide investment, tax, legal, or financial advice.",
      "Stablecoins can involve technical, issuer, regulatory, and market risks. Use only what you understand.",
    ],
  },
  {
    title: "Contact",
    body: [
      "Questions about these terms can be sent to support@textmono.com.",
    ],
  },
];

export function LegalPage({ kind }: { kind: "privacy" | "terms" }) {
  const isPrivacy = kind === "privacy";
  const sections = isPrivacy ? PRIVACY : TERMS;

  return (
    <main className="mono-legal-page">
      <article className="mono-legal">
        <span className="mono-legal__eyebrow">{isPrivacy ? "Privacy" : "Terms"}</span>
        <h1 className="mono-legal__title">
          {isPrivacy ? "Privacy Policy" : "Terms of Service"}
        </h1>
        <p className="mono-legal__intro">Effective August 23, 2026.</p>

        <div className="mono-legal__sections">
          {sections.map((section) => (
            <section className="mono-legal__section" key={section.title}>
              <h2>{section.title}</h2>
              <div>
                <p>{section.body.join(" ")}</p>
              </div>
            </section>
          ))}
        </div>
      </article>
    </main>
  );
}
